import SetPassword from '@/common/containers/Forms/SetPassword/SetPassword';

export default SetPassword;
